module.exports = __webpack_public_path__ + "media/images/lb/804-dfb5527195264d54729c5fab9052fbce.svg";